import React from 'react';
import './Mostimportantpropert.css';
import pvcmachi from '../../../imgs/pvcmachine.webp';


const Mostimportantpropert = () => {
    return (
        <div className="Advantagpall-container">
            <div className='Ordinarys'>
                <h2 className="Advantagpall-title">What are the most important properties of PVC?</h2>
                <div className="Advantagpall-content">
                    <ul className="Advantagpall-text">
                        <li>High hardness and excellent tensile strength (rigid PVC).</li>
                        <li>Easy plastic injection molding and machining.</li>
                        <li>Easy to obtain and cheap.</li>
                        <li>Addition of heat stabilizer during processing for high heat resistance.</li>
                        <li>Suitable for medium and low voltage and low frequency insulation applications.</li>
                    </ul>
                    <p className="Material-text">PVC is a thermoplastic that can
                        be easily injection molded and then recycled.</p>
                    <p className="Material-text">Economical production costs Combined with 
                        the above properties, PVC injection molding has become one of
                         the best and easiest options for manufacturing various
                          plastic products such as pipe fittings, used in the construction 
                        industry as well as in the agricultural industry.</p>
                    <p className="Material-date">Powerjet PVC injection molding machines</p>
                    <p className="Material-text">adopt a special PVC screw, which can effectively 
                        solve the problems of drawing and yellowing PVC products;
                         excellent air cooling control improves 
                        the stability of the PVC heat-sensitivity molding process.</p>
                    <p className="Material-text">Please feel free to contact us if you are looking
                         for a professional plastic molding machine manufacturer!</p>
                    <div className="advantpl">
                        <img src={pvcmachi} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Mostimportantpropert;
